<template>
  <div>
    <div class="side_bar">
      <Menu @onCheckMenu="hasMenu=$event" />
    </div>
    <header>
      <div class="headertop_main">
        <div class="container">
          <div class="header_top">
            <p>In partnership with the American Associatioan of Christian Counselors</p>
            <a href="https://www.aacc.net">
              <!-- eslint-disable-next-line vue/html-self-closing -->
              <img src="/images/aacc.png" alt="logo1" />
            </a>
            <a href="https://www.truelife.org">
              <!-- eslint-disable-next-line vue/html-self-closing -->
              <img src="/images/logo1.png" alt="logo1" />
            </a>
            <div class="clearfix" />
          </div>
        </div>
      </div>
      <div class="headerbot_main">
        <!-- <div class="container"> -->
        <div class="header_bottom d-flex flex-wrap">
          <template v-if="!hasMenu">
            <div class="logo logo1 col-12">
              <router-link :to="{ name: 'home' }">
                <!-- eslint-disable-next-line vue/html-self-closing -->
                <img src="/images/logo.png" alt="logo" />
              </router-link>
            </div>
          </template>
          <template v-else>
            <div class="logo col-sm-4">
              <router-link :to="{ name: 'home' }">
                <!-- eslint-disable-next-line vue/html-self-closing -->
                <img src="/images/logo.png" alt="logo" />
              </router-link>
            </div>
            <button @click="handleHamburger" class="nav_icon">
              <span />
              <span />
              <span />
            </button>
            <Menu />
          </template>
          <div class="clearfix" />
        </div>
        <!-- </div> -->
      </div>
    </header>
  </div>
</template>

<script>
import { isEmpty } from 'lodash'
import Menu from './Menu'
export default {
  name: 'Header',
  components: {
    Menu
  },
  data: () => ({
    hasMenu: false
  }),
  methods: {
    handleHamburger() {
      $('body').toggleClass('open_menu');
    }
  }
}
</script>
<style lang="scss">
/*--header start--*/

.headertop_main {
  background: #2ba349;
}
.header_top {
  display: block;
  text-align: center;
  padding: 7px 0 7px 0;
}
.header_top p {
  display: inline-block;
  vertical-align: middle;
  margin: 0;
  font-size: 18px;
  letter-spacing: 0.2px;
}
.header_top a {
  display: inline-block;
  vertical-align: middle;
  margin: 0 0 0 19px;
}

.headerbot_main {
}
.header_bottom {
  padding: 20px 0 15px 0;
  position: relative;
}

nav {
  padding: 0;
}
nav ul {
  /* margin: 0 -50px 0 0; */
  margin: 0;
  padding: 37px 0 0 0;
  float: right;
}
nav ul li {
  display: inline-block;
  margin: 0;
}
nav ul li a {
  font-size: 18px;
  line-height: 45px;
  color: #282828;
  font-weight: 500;
  text-transform: uppercase;
  display: block;
  padding: 0 15px;
  border-radius: 25px;
}
nav ul li a:hover {
  background: #2ba349;
  color: #ffffff;
}

.logo {
  padding: 0;
  margin: 0 0 0 -17px;
}
/*--header end--*/

.headerbot_main .logo a img {
  margin: auto;
}
.headerbot_main .header_bottom nav {
  text-align: center;
}
.headerbot_main .header_bottom nav ul {
  float: none;
}
.header_top a {
  margin-left: 20px;
  &:last-of-type {
    margin-left: 10px;
  }
}
</style>
